<template>
  <div>
    <px-oferta-duvidas-list ref="duvidasList"
                            is-fornecedor
                            :oferta="oferta"
                            :method-getter-fornecedor="ofertaService.getDuvidas"
                            :method-responder="ofertaService.responderDuvidas"/>
  </div>

</template>

<script>
import { required } from 'vuelidate/lib/validators';
import OfertaService from '../oferta-service';

export default {
  props: {
    oferta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      grupoId: this.$route.params.idGrupo,
      comprador: null,
      pergunta: null,
      loading: false,
      ofertaService: OfertaService,
    };
  },
  validations: {
    pergunta: {
      required,
    },
  },
};
</script>
